var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 14.3652L21.9003 20.965L20.2504 19.3149L25.2002 14.3652L20.2504 9.41549L21.9003 7.76558L28.5 14.3652ZM3.79983 14.3652L8.74958 19.3149L7.09966 20.965L0.5 14.3652L7.09966 7.76558L8.74958 9.41549L3.79983 14.3652ZM11.9199 24.8652H9.43677L17.0802 3.86523H19.5632L11.9199 24.8652Z",
    fill: "#191D23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_74"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5 0.365234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeSharp);
export default __webpack_public_path__ + "static/media/CodeSharp.6d122880f982094377aa8be9601ea16a.svg";
export { ForwardRef as ReactComponent };